import React from 'react'
import { Input, Container, Row, Col, Label, Button } from 'reactstrap'

class TextAreaModalController extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            value: props.value ? props.value : ''
        }
    }

    submit() {
        this.props.onChange(this.state.value)
    }

    handleKeyDown(e) {
        if (!e.shiftKey && e.key === 'Enter') {
            this.submit()
        }
    }

    render() {

        return (
            <Container>
                <Row>
                    <Col>
                        <Label style={{
                            'fontSize': '20px',
                            'fontWeight': '500',
                        }}
                            >{this.props.title || "Process"}</Label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Input
                            type="textarea"
                            value={this.state.value}
                            onKeyDown={(e) => this.handleKeyDown(e)}
                            onChange={(e) => {
                                this.setState({
                                    'value': e.target.value,
                                })
                            }}
                            style={{'width': '100%', 'height': '350px'}}
                            />
                    </Col>
                </Row>
                <Row>
                    <Col style={{'textAlign': 'right'}}>
                        <Button style={{
                            'marginTop': '8px',
                            'marginBottom': '8px'
                        }}
                        color='primary'
                        onClick={(e) => this.submit()}>Add</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export { TextAreaModalController }

